<template>
  <div id="Pois">
    <SovecoNavBar />
    <div class="columns is-variable is-0">
      <div class="column is-narrow">
        <div class="drivers_top_box">Punti di Interesse</div>
        <VueScrollTable
          :options="poisOpts"
          :columns="poisCols"
          :rows="poisRows"
        />
        <div class="drivers_bot_box columns">
          <div class="column">
            Per creare un nuovo POI fare click sulla mappa
          </div>
          <div class="column is-narrow">
            <figure class="image is-32x32 is-center">
              <img
                title="Rimozione POI"
                :class="[isEmptyObject(poiSel) ? 'greyed' : '', 'buttonimg']"
                src="images/trash-icon.png"
                @click="doDeletePOI"
              />
            </figure>
          </div>
        </div>
      </div>
      <div id="map_column" class="column">
        <modal name="poi" :draggable="true" :height="350">
          <div class="modal_style">
            <p class="control">
              <label class="label">Nome:</label>
              <input
                v-model="modal.name"
                class="input"
                type="text"
                placeholder="Nome del Punto di Interesse"
              />
              <label class="label">Descrizione:</label>
              <input
                v-model="modal.description"
                class="input"
                type="text"
                placeholder="Descrizione breve"
              />
            </p>
            <div class="columns is-left-padding">
              <div class="column">
                <label class="label">Colore:</label>
                <compact-picker v-model="colors" />
              </div>
              <div class="column">
                <label class="label">Forma:</label>
                <table>
                  <tr>
                    <td>
                      <img
                        src="images/square.png"
                        alt="quadrato"
                        height="42"
                        width="42"
                      />
                    </td>
                    <td>
                      <img
                        src="images/triang.png"
                        alt="triangolo"
                        height="42"
                        width="42"
                      />
                    </td>
                    <td>
                      <img
                        src="images/circle.png"
                        alt="cerchio"
                        height="42"
                        width="42"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center">
                      <input
                        id="1"
                        v-model="modal.poi_type"
                        type="radio"
                        value="1"
                      />
                    </td>
                    <td style="text-align: center">
                      <input
                        id="2"
                        v-model="modal.poi_type"
                        type="radio"
                        value="2"
                      />
                    </td>
                    <td style="text-align: center">
                      <input
                        id="3"
                        v-model="modal.poi_type"
                        type="radio"
                        value="3"
                      />
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="columns">
              <div class="column" />
              <div class="column">
                <div class="is-pulled-right modal_buttons">
                  <a class="button" @click="deleteModal">Annulla</a
                  >&nbsp;&nbsp;&nbsp;<a class="button" @click="okModal"
                    >Conferma</a
                  >
                </div>
              </div>
            </div>
          </div>
        </modal>
        <GmapMap
          id="gmap"
          ref="mmm"
          class="map-container"
          :center="center"
          :zoom="zoom"
          @click="clicked"
          @zoom_changed="zoomChange"
        >
          <template v-if="google !== undefined || google !== null">
            <GmapMarker
              v-for="m in poisRows"
              :key="m.id"
              :position="{
                lat: parseFloat(m.latitude),
                lng: parseFloat(m.longitude),
              }"
              :clickable="true"
              :draggable="false"
              :icon="createIcon(m, zoomNow, google)"
              @click="editMarker(m)"
            />
            <GmapMarker
              v-for="m in lastPos"
              :key="m.cod"
              :position="{
                lat: parseFloat(m.latitude),
                lng: parseFloat(m.longitude),
              }"
              :clickable="true"
              :draggable="false"
              :icon="getIcon(m)"
            />
            <div v-if="modal.visible">
              <GmapMarker
                :position="{
                  lat: parseFloat(modal.latitude),
                  lng: parseFloat(modal.longitude),
                }"
                :clickable="false"
                :draggable="false"
                :icon="createIcon(modal, zoomNow, google)"
              />
            </div>
          </template>
        </GmapMap>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { ServiceBus } from '../ServiceBus.js'
import { UtilityMixin } from '../mixins/UtilityMixin.js'
import VueScrollTable from './reusable/VueScrollTable.vue'
import VueColor from 'vue-color'
import { gmapApi } from 'gmap-vue'

export default {
  name: 'Pois',
  components: {
    VueScrollTable,
    'compact-picker': VueColor.Compact,
  },
  mixins: [UtilityMixin],

  data() {
    return {
      api_server: '',
      auth: null,
      prefs: null,
      windowHeight: 0,
      zoomNow: 12,
      zoom: 12,
      center: {
        lat: 45,
        lng: 11,
      },
      lastPos: [],
      poisRows: [],
      poiSel: {},
      poiTemp: null,
      deleteAlert: true,
      poisOpts: {
        id: 'PO001',
        isResizeable: false,
        isSelectable: true,
        cssContainer: 'drivers_list_container',
        cssHeader: 'drivers_list_header',
        cssBody: 'drivers_list',
        cssRows: 'drivers_list',
        order_col: 'name',
      },
      poisCols: [
        {
          id: 'name',
          visible: true,
          f_type: '*',
          title: 'Punto Interesse',
          width: 200,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'description',
          visible: true,
          f_type: '*',
          title: 'Descrizione',
          width: 200,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: 1,
          image: false,
        },
      ],
      shape: 1,
      colors: '#f00',
      modal: {
        id: null,
        cod: null,
        title: 'Punto di Interesse',
        visible: false,
        name: '',
        description: '',
        poi_type: 0,
        poi_color: '#FFFFFF',
        latitude: 0.0,
        longitude: 0.0,
      },
    }
  },
  computed: {
    google: gmapApi,
  },
  watch: {
    colors(val) {
      this.modal.poi_color = val.hex
    },
  },
  created() {
    const vm = this
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  mounted() {
    const vm = this
    vm.api_server = vm.getApiServer()
    if (vm.auth === null || vm.auth.tipo == 3) {
      this.$router.push({
        path: 'login',
      })
    }
    vm.$nextTick(function () {
      window.removeEventListener('resize', null)
      window.addEventListener('resize', vm.getWindowHeight)
      vm.$refs.mmm.$mapPromise.then((map) => {})
      vm.getWindowHeight()
      vm.do_get_pois()
      vm.doGetLastPos()
    })
  },
  methods: {
    colClick(id, col, item) {
      const vm = this
      vm.poiSel = item
      vm.centerMarker(item)
    },
    okModal() {
      // you can set modal show or hide with the variable 'this.modal.visible' manually
      // this.modal.visible = false;
      const vm = this
      vm.do_save_poi()
    },
    deleteModal() {
      this.showModal()
    },
    editMarker(item) {
      const vm = this
      if (vm.modal.visible) {
        vm.showModal()
      }
      vm.modal = item
      vm.modal.visible = false
      vm.showModal()
    },
    clearSel() {
      const vm = this
      vm.poiSel = {}
    },
    showModal() {
      const vm = this
      vm.modal.visible = !vm.modal.visible
      vm.modal.cod = vm.auth.cod
      if (vm.modal.visible) {
        vm.$modal.show('poi', { draggable: true })
      } else {
        vm.$modal.hide('poi')
      }
    },
    zoomChange(e) {
      this.zoomNow = e
    },
    clicked(e) {
      const vm = this
      vm.modal.id = null
      vm.modal.name = 'Nome punto di interesse'
      vm.modal.description = 'Descrizione breve punto di interesse'
      vm.modal.cod = vm.auth.cod
      vm.modal.latitude = e.latLng.lat()
      vm.modal.longitude = e.latLng.lng()
      vm.modal.poi_type = 1
      vm.modal.poi_color = '#FF0000'
      vm.showModal()
    },
    centerAllMarkersPois() {
      const vm = this
      let bounds = vm.getMapBounds(vm.poisRows, vm.google)
      vm.$refs.mmm.$mapPromise.then(() => {
        vm.$refs.mmm.$mapObject.fitBounds(bounds)
        vm.center = vm.$refs.mmm.$mapObject.getCenter()
      })
    },
    centerMarker(item) {
      const vm = this
      let pos = {
        lat: parseFloat(item.latitude),
        lng: parseFloat(item.longitude),
      }
      let bounds = vm.getPosBounds(pos, vm.google)
      vm.$refs.mmm.$mapPromise.then(() => {
        vm.$refs.mmm.$mapObject.fitBounds(bounds)
        vm.center = vm.$refs.mmm.$mapObject.getCenter()
      })
    },
    async do_save_poi() {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'replace_poi',
          vm.modal,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        vm.showModal()
        vm.do_get_pois()
        vm.$dialog
          .alert('POI salvato')
          .then(function () {})
          .catch(function () {})
      } catch (e) {
        console.log('error ' + e)
      }
    },
    async do_get_pois() {
      const vm = this
      try {
        const response = await axios.get(
          vm.api_server + 'get_pois/' + vm.auth.cod,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          if (response.data) {
            vm.poisRows = response.data
            vm.centerAllMarkers()
          }
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },
    doDeletePOI() {
      const vm = this
      if (!vm.isEmptyObject(vm.poiSel)) {
        let str
        str =
          'Confermare la rimozione del punto di interesse <br>' + vm.poiSel.name
        vm.$dialog
          .confirm(str)
          .then(function () {
            vm.deletePoi()
          })
          .catch(function () {})
      }
    },
    cancelEntry() {
      const vm = this
      ServiceBus.$emit('deselect')
      vm.clearSel()
    },
    async deletePoi() {
      const vm = this
      try {
        const response = await axios.delete(
          vm.api_server + 'delete_poi/' + vm.poiSel.id,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        vm.do_get_pois()
        vm.cancelEntry()
      } catch (e) {
        console.log('error ' + e)
      }
    },
    centerAllMarkers() {
      const vm = this
      let bounds = vm.getMapBounds(vm.lastPos)
      vm.$refs.mmm.$mapPromise.then(() => {
        vm.$refs.mmm.$mapObject.fitBounds(bounds)
        vm.center = vm.$refs.mmm.$mapObject.getCenter()
      })
    },

    getIcon(obj) {
      const vm = this
      let colorMode
      let color = 'rgb(51,204,51)'
      switch (obj.mode) {
        case '0':
          colorMode = 'rgb(0,255,0)'
          break
        case '1':
          colorMode = 'rgb(255,0,0)'
          break
        case '2':
          colorMode = 'rgb(0,0,0)'
          break
      }
      let mySvg
      let myIcon
      mySvg =
        'data:image/svg+xml;utf-8, \
      <svg width="55" height="61" viewBox="0 0 55 61" xmlns="http://www.w3.org/2000/svg"> \
      <polyline points="1,33  54,33  54,50 35,50 30,60 25,50 1,50 1,33" style="stroke:' +
        colorMode +
        '; stroke-width: 2; fill: ' +
        color +
        ';"/>\
       <text x="4" y="45" fill="black"  font-size="10">' +
        obj.targa +
        '</text></svg>'
      myIcon = {
        url: mySvg,
        anchor: new vm.google.maps.Point(22, 60),
        size: new vm.google.maps.Size(55, 61),
      }

      return myIcon
    },
    async doGetLastPos() {
      const vm = this
      try {
        const response = await axios.get(
          vm.api_server + 'get_last_pos/' + vm.auth.cod,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.lastPos = response.data

          vm.centerAllMarkers()
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },
    getWindowHeight(event) {
      const vm = this
      vm.windowHeight = document.documentElement.clientHeight
      document
        .getElementById('gmap')
        .setAttribute('style', 'height:' + (vm.windowHeight - 70) + 'px')
      document
        .getElementById(vm.poisOpts.id + 'bw')
        .setAttribute('style', 'height:' + (vm.windowHeight - 224) + 'px')
    },
    beforeDestroy() {
      const vm = this
      window.removeEventListener('resize', vm.getWindowHeight)
    },
  },
}
</script>

Ch1-rz$JY4wIQb?AQ
